import { Flex, themedColor } from '@lemonade-hq/cdk';
import React from 'react';
import styled from 'styled-components';
import { MediumSmallTitle } from '../shared';
import { GridCell } from './shared';

const PositiveChange = styled.span`
  color: ${themedColor('eucalyptus')};
`;

const NegativeChange = styled.span`
  color: ${themedColor('darkestRed')};
`;

export const GridContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  border: solid 1px ${themedColor('alto')};
  border-radius: 10px;
  overflow: hidden;
  font-size: 1.6rem;
  text-align: center;

  & > div:nth-last-child(-n + 2) {
    border: none;
  }
`;

const TimeInfo = styled.p`
  font-size: 1.4rem;
  color: ${themedColor('textTertiary')};
  text-wrap: pretty;
`;

export interface StockInfo {
  symbol: string;
  price: number;
  change: number;
  percentChange: number;
  todaysOpen: number;
  previousClose: number;
  intradayHigh: number;
  intradayLow: number;
  week52High: number;
  week52Low: number;
  volume: string;
  lastUpdated: string;
}

interface PricingTableProps {
  stockInfo: StockInfo;
}

export const PricingTable: React.FC<PricingTableProps> = ({ stockInfo }) => {
  return (
    <Flex flexDirection="column" width="100%" gap="18px">
      <MediumSmallTitle>Lemonade Stock Quote</MediumSmallTitle>

      <Flex flexDirection={['column', 'row']} gap="20px" alignItems="flex-start">
        <GridContainer>
          <GridCell align="left">Price</GridCell>
          <GridCell align="right">${stockInfo.price.toFixed(2)}</GridCell>

          <GridCell align="left">Change</GridCell>
          <GridCell align="right">
            {stockInfo.change > 0 ? (
              <PositiveChange>+{stockInfo.change.toFixed(2)}</PositiveChange>
            ) : (
              <NegativeChange>{stockInfo.change.toFixed(2)}</NegativeChange>
            )}
          </GridCell>

          <GridCell align="left">% Change</GridCell>
          <GridCell align="right">
            {stockInfo.percentChange > 0 ? (
              <PositiveChange>+{stockInfo.percentChange.toFixed(2)}%</PositiveChange>
            ) : (
              <NegativeChange>{stockInfo.percentChange.toFixed(2)}%</NegativeChange>
            )}
          </GridCell>

          <GridCell align="left">Today&apos;s Open</GridCell>
          <GridCell align="right">${stockInfo.todaysOpen.toFixed(2)}</GridCell>

          <GridCell align="left">Previous Close</GridCell>
          <GridCell align="right">${stockInfo.previousClose.toFixed(2)}</GridCell>
        </GridContainer>
        <GridContainer>
          <GridCell align="left">Intraday High</GridCell>
          <GridCell align="right">${stockInfo.intradayHigh.toFixed(2)}</GridCell>
          <GridCell align="left">Intraday Low</GridCell>
          <GridCell align="right">${stockInfo.intradayLow.toFixed(2)}</GridCell>
          <GridCell align="left">52 Week High</GridCell>
          <GridCell align="right">${stockInfo.week52High.toFixed(2)}</GridCell>
          <GridCell align="left">52 Week Low</GridCell>
          <GridCell align="right">${stockInfo.week52Low.toFixed(2)}</GridCell>
        </GridContainer>
      </Flex>
      <TimeInfo>Pricing delayed by 20 minutes.</TimeInfo>
    </Flex>
  );
};
